module.exports = __webpack_public_path__ + "media/app_search/Billing/assets/credit_cards/mastercard-b2c377675e2dd6fed6af3de30495c586.svg";